import { render, staticRenderFns } from "./LegislationView.vue?vue&type=template&id=fb917bee&scoped=true&"
import script from "./LegislationView.vue?vue&type=script&lang=js&"
export * from "./LegislationView.vue?vue&type=script&lang=js&"
import style0 from "./LegislationView.vue?vue&type=style&index=0&id=fb917bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb917bee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VCol,VContainer,VRow,VSheet})
